import { AxiosPromise } from 'axios';
import { shopPrefix } from '../../../config';
import { http } from '../../axios';
import {
    CampaignResult,
    CUMULATIVE_LOANS_KEY,
    CUMULATIVE_USERS_KEY,
    CumulativeLoansResponse,
    CumulativeUsersResponse,
    TOTAL_LOANS_KEY,
    TOTAL_LOANS_SHARED_KEY,
    TotalLoansResponse,
    TotalLoansSharedResponse,
    VISITS_KEY,
    VisitsResponse
} from './campaignTypes';

const endpointDiagramCumulativeLoans = `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/cumulativeloans`;
const endpointDiagramCumulativeUser = `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/cumulativeusers`;
const endpointDiagramTotalLoans = `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/totalloans`;
const endpointDiagramTotalLoansSharedOnly = `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/totalloans/shared`;
const endpointVisits = `${shopPrefix}/v1/marketing/campaigns/:campaignProductId/visits`;

function fetchCumulativeUsersDiagram(campaignProductId: string): AxiosPromise<CumulativeUsersResponse> {
    return http
        .get(endpointDiagramCumulativeUser, { pathParams: { campaignProductId } })
        .then(response => response.data);
}

function fetchTotalLoansDiagram(campaignProductId: string): AxiosPromise<TotalLoansResponse> {
    return http.get(endpointDiagramTotalLoans, { pathParams: { campaignProductId } }).then(response => response.data);
}

function fetchTotalLoansDiagramSharedOnly(campaignProductId: string): AxiosPromise<TotalLoansSharedResponse> {
    return http
        .get(endpointDiagramTotalLoansSharedOnly, { pathParams: { campaignProductId } })
        .then(response => response.data);
}

function fetchVisits(campaignProductId: string): AxiosPromise<VisitsResponse> {
    return http.get(endpointVisits, { pathParams: { campaignProductId } }).then(response => response.data);
}

function fetchCumulativeLoansDiagram(campaignProductId: string): AxiosPromise<CumulativeLoansResponse> {
    return http
        .get(endpointDiagramCumulativeLoans, { pathParams: { campaignProductId } })
        .then(response => response.data);
}

export async function fetchCampaignAnalytics(campaignProductId: string): Promise<CampaignResult> {
    return Promise.all([
        fetchCumulativeLoansDiagram(campaignProductId),
        fetchTotalLoansDiagram(campaignProductId),
        fetchCumulativeUsersDiagram(campaignProductId),
        fetchVisits(campaignProductId)
    ]).then(data => {
        const results = {} as CampaignResult;
        results[CUMULATIVE_LOANS_KEY] = data[0] as unknown as CumulativeLoansResponse;
        results[TOTAL_LOANS_KEY] = data[1] as unknown as TotalLoansResponse;
        results[CUMULATIVE_USERS_KEY] = data[2] as unknown as CumulativeUsersResponse;
        results[VISITS_KEY] = data[3] as unknown as VisitsResponse;
        return results;
    });
}

export async function fetchCampaignAnalyticsForPartner(campaignProductId: string): Promise<CampaignResult> {
    return Promise.all([
        fetchCumulativeLoansDiagram(campaignProductId),
        fetchTotalLoansDiagram(campaignProductId),
        fetchCumulativeUsersDiagram(campaignProductId),
        fetchTotalLoansDiagramSharedOnly(campaignProductId),
        fetchVisits(campaignProductId)
    ]).then(data => {
        const results = {} as CampaignResult;
        results[CUMULATIVE_LOANS_KEY] = data[0] as unknown as CumulativeLoansResponse;
        results[TOTAL_LOANS_KEY] = data[1] as unknown as TotalLoansResponse;
        results[CUMULATIVE_USERS_KEY] = data[2] as unknown as CumulativeUsersResponse;
        results[TOTAL_LOANS_SHARED_KEY] = data[3] as unknown as TotalLoansSharedResponse;
        results[VISITS_KEY] = data[4] as unknown as VisitsResponse;
        return results;
    });
}
